import { useEntitlements } from "src/hooks/use-entitlement";
import { NavSection } from "src/components/layout/nav/nav-section";

import { Icon } from "src/components/layout/nav/icons/event-collection";
import type { ActiveSectionProps } from "src/components/layout/nav/utils";
import type { UseSectionHook } from "./types";
import { useFlags } from "launchdarkly-react-client-sdk";

// Event Studio branding is internal-only (externally still visible as "Contracts").
const EventCollectionLinks = [
  {
    isSub: true,
    href: "/events/library",
    label: "Event library",
  },
  {
    isSub: true,
    href: "/events/domains",
    label: "Contracts",
  },
  {
    isSub: true,
    href: "/events/syncs",
    label: "Event syncs",
  },
  {
    isSub: true,
    href: "/events/sources",
    label: "Event sources",
  },
  {
    isSub: true,
    href: "/events/destinations",
    label: "Event destinations",
  },
  {
    isSub: true,
    href: "/events/functions",
    label: "Functions",
  },
];

const RealtimeAudienceEnabledLinks = [
  {
    isSub: true,
    href: "/events/sources",
    label: "Event sources",
  },
];

export const useEventCollectionSection: UseSectionHook = () => {
  const { enableRealtimeAudiencesSetup } = useFlags();
  // Not `useRealtimeAudiencesEnabled`, which suspends — `<Nav />` renders
  // outside the layout's `<Suspense>` boundary. Visibility is cosmetic, so a
  // briefly-false read only costs a flicker.
  const { data: entitlementsData } = useEntitlements(false);
  const realtimeAudiencesEnabled =
    entitlementsData.entitlements.realtimeAudiences;

  return {
    title: "Event Collection",
    isEnabled:
      entitlementsData.entitlements.events ||
      realtimeAudiencesEnabled ||
      enableRealtimeAudiencesSetup,
    links: entitlementsData.entitlements.events
      ? EventCollectionLinks
      : realtimeAudiencesEnabled || enableRealtimeAudiencesSetup
        ? RealtimeAudienceEnabledLinks
        : [],
  };
};

export const EventCollection = (props: ActiveSectionProps) => {
  const section = useEventCollectionSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
